module.exports = __webpack_public_path__ + "static/media/t-line-safes.5d1db174.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/model-serial-number/t-line-safes.png
// module id = 1300
// module chunks = 0